import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { CancelWithConfirmation } from '../../state/preautorisation.actions';

@Component({
  selector: 'app-boite-annulation',
  templateUrl: './boite-annulation.component.html',
  styleUrls: ['boite-annulation.component.scss'],
  standalone: false
})
export class BoiteAnnulationComponent {
  constructor(private readonly _store: Store) {}

  async showModal() {
    await this._store.dispatch(new CancelWithConfirmation()).toPromise();
  }
}
